<template>
<div class="not_eng_item_box_bb">
     <el-row class="not_eng_item_row" v-for="item in listArr" :key="item.id">
      <el-col :span="2"> <div class="p1">{{item.modifyTimes}}</div></el-col>
      <el-col :span="2"> <div class="p1">&nbsp;</div></el-col>
      <el-col :span="22">
        <p class="p2" @click="detailClick(item)">{{item.title}}</p>
        <!-- <p class="p3" @click="detailClick(item)">{{item.content}}</p> -->
      </el-col>
    </el-row>
  </div>
  
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
export default {
  components: {},
  data() {
    return {
      listArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    consultation() {
      let that = this;
      that.ajaxJson({
        url: "/siteManage/contentList",
        data:{
          type: 2
        },
        success: function(data) {
          if (data.code == "0000") {
            console.info(data);
            that.listArr = data.data;
          }
        }
      });
    },
    detailClick(item) {
      let that = this;
      that.$router.push({name:'detail',query: item})
    }
  },
  created() {
    let that = this;
    that.consultation();
  }
};
</script>
<style>
.index-footer {
  background: #fff;
  border-top: rgba(34, 34, 34, 0.1) solid 1px;
  position: relative;
  bottom: 0;
}
.index-footer_box {
  padding: 47px 260px;
}
.index-footer_bom .index-footer_bom_box {
  padding: 0px 260px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(154, 154, 154, 1);
  line-height: 36px;
}
.index-footer_bom {
  background: rgba(247, 247, 247, 1);
}
.index-footer_box .span1 {
  display: inline-block;
  padding-top: 30px;
}
.notice_right_news {
  display: inline-block;
  border-left: rgba(34, 34, 34, 0.1) solid 1px;
  padding: 0 60px;
  border-right: rgba(34, 34, 34, 0.1) solid 1px;
}
.notice_right_news .notice_right_phone {
  height: 36px;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 36px;
}
.notice_right_news .notice_right_title {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 16px;
}
.notice_right_news .notice_right_border {
  width: 15px;
  height: 2px;
  background: rgba(34, 34, 34, 1);
  margin: 10px 0 12px 0;
}
.notice_right_news .notice_right_data1 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 8px;
}
.notice_right_news .notice_right_data2 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 20px;
}
.notice_right_news .notice_content {
  width: 1px;
  height: 115px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.5;
}
.index-footer_code img {
  /* width: 78px; */
  display: inline-block;
}
.index-footer_code .index-footer_wexin {
  padding-top: 70px;
}
.not_eng_item_row{
      height: 141px;
      overflow: hidden;
    /* background: rgba(247,247,247,1); */
    padding: 20px;
}
.not_eng_item_row:hover{
    background: rgba(247,247,247,1);
    cursor:pointer
}
.not_eng_item_box_bb {
  width: 100%;
}
.not_eng_item_box_bb .p1{
  font-size: 22px;
      line-height: 52px;
}
.not_eng_item_row .p2{
  font-size:22px;
  font-family:Helvetica;
  color:rgba(0,0,0,1);
  font-weight: bold;
}
.not_eng_item_row .p3{
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size:12px;
font-family:Helvetica;
color:rgba(91,91,91,1);
}
/* .not_eng_item img {
  width: 310px;
  height: 185px;
} */
.not_eng_item .p2 {
  font-size: 18px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 1);
  line-height: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/bb.vue